import { render } from "./ApplicationSlogan.vue?vue&type=template&id=a5917d0c"
const script = {}
script.render = render

export default script